import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "id", "label"];
import PropTypes from 'prop-types';
import { cloneElement } from 'react';
import useUniqueId from 'react-utils/hooks/useUniqueId';
import styled from 'styled-components';
import { warnIfFragment } from '../utils/devWarnings';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const InlineLabel = styled.label.withConfig({
  displayName: "UIInlineLabel__InlineLabel",
  componentId: "sc-1db89fs-0"
})(["display:inline-flex;align-items:center;margin-right:12px;"]);
const LabelText = styled.div.withConfig({
  displayName: "UIInlineLabel__LabelText",
  componentId: "sc-1db89fs-1"
})(["flex-shrink:0;margin-right:8px;user-select:none;"]);
const UIInlineLabel = props => {
  const {
      children,
      id,
      label
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const defaultId = useUniqueId(`uiinlinelabel-`);
  const computedId = id || defaultId;
  warnIfFragment(children, UIInlineLabel.displayName);
  return /*#__PURE__*/_jsxs(InlineLabel, Object.assign({}, rest, {
    id: computedId,
    children: [/*#__PURE__*/_jsx(LabelText, {
      children: label
    }), /*#__PURE__*/cloneElement(children, {
      'aria-labelledby': computedId
    })]
  }));
};
UIInlineLabel.propTypes = {
  children: PropTypes.element.isRequired,
  label: PropTypes.node.isRequired
};
UIInlineLabel.displayName = 'UIInlineLabel';
export default UIInlineLabel;